import HTTP from "../http";
import Jsona from "jsona";
import paramsHelper from "../helpers/params";

const dataFormatter = new Jsona();

export default {
  async getOptionsByConfigurableField(configurableFieldId) {
    try {
      const filters = [
        { name: "configurable_field_id", value: configurableFieldId }
      ];

      const params = paramsHelper.buildParams({ filters });

      const results = await HTTP.normal.get(
        `/configurable-field-options${params}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (_) {
      throw "Ocorreu um erro ao listar as preferências!";
    }
  },

  async show(id) {
    try {
      const configurableFieldOption = await HTTP.normal.get(
        `/configurable-field-options/${id}`
      );

      return dataFormatter.deserialize(configurableFieldOption.data);
    } catch (_) {
      throw "Ocorreu um erro ao buscar a opção da preferência do pedido!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/configurableFieldOption.js